import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./headerContainer.html";
import { selectUrl, WireStore } from '@oneappexchange/lwc-wired';
import { MAINTENANCE_BANNER_ENDDATE, MAINTENANCE_BANNER_STARTDATE, SHOW_ANNOUNCEMENT_BANNER, SHOW_MAINTENANCE_BANNER } from '~/config';
import { headerStore, selectShowSubmenu } from '~/modules/stores/headerStore';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { LISTING_EDITOR_ROUTE, routerStore, SECURITY_REVIEW_EDITOR_ROUTE } from '~/modules/stores/routerStore';
class HeaderContainer extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listingItem = void 0;
    this.useEditorHeader = false;
    this.useSecurityHeader = false;
    this.useCommonHeader = true;
    this.showMaintenanceBanner = SHOW_MAINTENANCE_BANNER === 'true';
    this.showAnnouncementBanner = SHOW_ANNOUNCEMENT_BANNER === 'true';
    this.labels = {};
    this.showSubmenu = void 0;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.globalHeader;
  }
  urlUpdated(url) {
    this.useEditorHeader = LISTING_EDITOR_ROUTE === url;
    this.useSecurityHeader = SECURITY_REVIEW_EDITOR_ROUTE === url;
    this.useCommonHeader = !(this.useEditorHeader || this.useSecurityHeader);
  }
  get cssClass() {
    let result = 'container';
    if (this.useEditorHeader) {
      result += ' editor-header';
    }
    return result;
  }
  get maintenanceBannerLabel() {
    return i18nStore.getState().i18n.globalHeader.maintenanceAlertTitle({
      START_DATE: MAINTENANCE_BANNER_STARTDATE,
      END_DATE: MAINTENANCE_BANNER_ENDDATE
    });
  }
  handleCloseMaintenanceAlert() {
    this.showMaintenanceBanner = false;
  }
  handleCloseAnnouncementAlert() {
    this.showAnnouncementBanner = false;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HeaderContainer, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    showSubmenu: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: headerStore,
          selector: selectShowSubmenu
        };
      }
    },
    urlUpdated: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: selectUrl
        };
      }
    }
  },
  fields: ["listingItem", "useEditorHeader", "useSecurityHeader", "useCommonHeader", "showMaintenanceBanner", "showAnnouncementBanner", "labels"]
});
const __lwc_component_class_internal = _registerComponent(HeaderContainer, {
  tmpl: _tmpl,
  sel: "page-header-container",
  apiVersion: 62
});
export default __lwc_component_class_internal;